import React from 'react';

export interface EmptyStateProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  body?: string; // backwards-compatible alias for description
  action?: React.ReactNode;
  secondaryAction?: React.ReactNode;
  className?: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  icon,
  title,
  description,
  body,
  action,
  secondaryAction,
  className = '',
  ...rest
}) => {
  const descriptionText = description ?? body;

  return (
    <div
      {...rest}
      className={`flex flex-col items-center justify-center text-center border border-dashed border-base-300 rounded-2xl p-8 lg:p-12 ${className}`}
    >
      {icon && (
        <div className="flex items-center justify-center size-12 rounded-xl bg-neutral text-base-content/60 mb-4 shrink-0 [&>svg]:size-6">
          {icon}
        </div>
      )}
      <h3 className="text-base font-bold text-base-content mb-1">{title}</h3>
      {descriptionText && (
        <p className="text-sm text-base-content/60 max-w-sm mx-auto leading-6 mb-5">
          {descriptionText}
        </p>
      )}
      {(action || secondaryAction) && (
        <div className="flex flex-wrap items-center justify-center gap-3 mt-1">
          {action}
          {secondaryAction}
        </div>
      )}
    </div>
  );
};

EmptyState.displayName = 'EmptyState';
